import { Helmet } from "react-helmet-async";
// import TestimonialDisplay from "../../components/staticView/TestimonialDisplay";

const data = [
  {
    name: "Dr. Shriya Soni",
    image: "/About/shriya.jpg",
    title1: "Co-founder",
    title2: "Managing partner",
    desc1:
      "Dr. Shriya Soni is a Senior Prosthodontist with over 10 years of clinical experience, focusing on cosmetic and implant dentistry. Shriya is based out of New Delhi, India and during the last 10 years, has also managed private practices in India as well as UK.",
    desc2:
      "When it comes to her treatments and restorations, Shriya is a fanatic for precision. It is this passion, that has led her into digital dentistry. Having seen and experienced the possibilities that digital dentistry can offer, Shriya has become a firm believer of the benefits it can bring to labs and practices. She co-founded Toothsketch with Dr. Hrisith Choksi as their initiative to further bring these advances into mainstream dentistry.",
    desc3:
      "When Shriya is not planning complex cases with her team or plugged into advancing her knowledge of latest developments in digital dentistry, you will find her traveling across the world or painting in her studio.",
  },
  {
    name: "Dr. Hrisith Choksi",
    image: "/About/hrisith.jpg",
    title1: "Co-founder",
    title2: "Head of accounts",
    desc1:
      "Dr. Hrisith Choksi comes with over a decade of experience as a general dental practitioner in London, with a focus on restorative and implant dentistry. This expertise is further strengthened through various certifications and accreditation from varied renowned institutions that he has gained over the years.",
    desc2:
      "Hrisith has been at the forefront of digital dentistry, applying it extensively across a variety of treatments. He believes that digital dentistry could revolutionize treatment planning, clinical outcomes and enhance patient experience. It was this shared belief with Dr. Shriya Soni that led him to co-found Toothsketch.",
    desc3:
      "Hrisith is an avid photographer who loves to cover nature and wildlife. When he is not working on building Toothsketch, you will find him driving through remote forests with his German Shepard Dog and Sony Alpha 7III.",
  },
];

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>About Us</title>
      </Helmet>
      <div className="h-full bg-black text-white flex flex-col py-12 md:py-[8vw] gap-12 md:gap-[8vw] md:px-[5vw]">
        <h1 className="md:text-[4vw] font-bold text-center md:text-start text-3xl">
          About Us
        </h1>
        <div className="flex flex-col items-center justify-center">
          <div className="flex flex-col items-center justify-center px-8 md:px-0">
            <div className="w-full min-h-[50vh] py-8 md:py-[3vw] flex flex-col md:flex-row items-center justify-center bg-black gap-4 md:gap-[2vw]">
              <div className="w-full h-full rounded-2xl md:rounded-[1vw] overflow-hidden transition-all duration-500 cursor-pointer">
                <img
                  src="/About/OurStory.webp"
                  alt="Our Story"
                  className="w-full h-full object-cover hover:scale-110 transition-all duration-500"
                />
              </div>
              <div className="w-full h-full flex flex-col justify-center md:gap-[4vw]">
                <h1 className="md:text-[4vw] font-bold text-center md:text-start text-3xl">
                  Our Story
                </h1>
                <p className="md:text-[1.2vw] text-justify">
                  ToothSketch was founded with the single mission of bringing
                  the best that digital dentistry has to offer to leading dental
                  labs and practices. Leading practitioners across the world are
                  adopting digital dentistry for better clinical outcomes and we
                  at ToothSketch are providing the CAD design support that is
                  needed to enable our partners to take the leap and prepare for
                  the future. Our plug and play model allows for easy and
                  seamless integration with your existing set-up, freeing you up
                  to scale up and operate at the next level. Please drop us a
                  line and we will be happy to get in touch and see how we can
                  help you!
                </p>
              </div>
            </div>

            <div className="w-full min-h-[50vh] py-8 md:py-[3vw] flex flex-col md:flex-row-reverse items-center justify-center bg-black gap-8 md:gap-[2vw]">
              <div className="w-full h-full rounded-2xl md:rounded-[1vw] overflow-hidden transition-all duration-500 cursor-pointer">
                <img
                  src="/About/WhyUs.jpeg"
                  alt="Why Us?"
                  className="w-full h-full object-cover hover:scale-110 transition-all duration-500"
                />
              </div>
              <div className="w-full h-full flex flex-col justify-center gap-4 md:gap-[4vw]">
                <h1 className="md:text-[4vw] font-bold text-center md:text-start text-3xl">
                  Why Us?
                </h1>
                <div className="flex flex-col gap-4">
                  <ul className="list-disc pl-5 md:text-[1.2vw] flex flex-col gap-2">
                    <li>Quality assurance</li>
                    <li>
                      Oversight by experienced dentists and dental technicians
                    </li>
                    <li>Free up your bandwidth to grow your business</li>
                    <li>Save on digitization set up costs and time</li>
                    <li>
                      Convert your recurring fixed costs into variable costs
                    </li>
                    <li>Better mange workflow volatility</li>
                    <li>Scale up at short notice</li>
                    <li>Cost efficiencies</li>
                  </ul>
                  <p className="md:text-[1.4vw] md:leading-[2vw] text-justify">
                    We offer flexible engagement models tailored to meet your
                    specific needs
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial slider */}
            {/* <div className="w-full h-full">
              <TestimonialDisplay/>
            </div> */}

            <div>
              <div className="bg-black w-full h-full text-white py-12 md:py-[5vw] px-2 md:px-[8vw] flex flex-col md:flex-row justify-evenly gap-10 md:gap-[10vw]">
                {data.map((item, index) => (
                  <div
                    key={index}
                    className="w-full h-full flex flex-col items-center gap-8 md:gap-[2vw]"
                  >
                    <div className="w-[25vh] md:w-[12vw] h-[30vh] md:h-[15vw] rounded-2xl overflow-hidden cursor-pointer">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-full h-full object-cover hover:scale-110 duration-500"
                      />
                    </div>
                    <div className="w-full h-full flex flex-col justify-center items-center md:gap-[1vw]">
                      <h2 className="text-xl md:text-[3vw] font-bold text-blue-400">
                        {item.name}
                      </h2>
                      <div className="items-center flex flex-col justify-center gap-1">
                        <p className="text-sm md:text-[1.2vw] text-gray-400">
                          {item.title1}
                        </p>
                        <p className="text-sm md:text-[1.2vw] text-gray-400">
                          {item.title2}
                        </p>
                      </div>
                      <p className="text-sm md:text-[1.2vw] text-justify leading-relaxed text-gray-200">
                        {item.desc1}
                        <br />
                        <br />
                        {item.desc2} <br />
                        <br />
                        {item.desc3}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
